module.exports = __webpack_public_path__ + "07d81517c33a1f61c53338fc6221e8e5.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Bold.ttf
// module id = 348
// module chunks = 0